module.exports = __webpack_public_path__ + "img/Mountain-Bike.ba59873.svg";